import { URLSearchParamsInit } from 'react-router-dom';
import { Params } from 'ahooks/lib/useAntdTable/types';
import { SorterResult } from 'antd/lib/table/interface';
import { RawAxiosRequestHeaders } from 'axios';
import dayjs from 'dayjs';

import { apiGet } from 'api';

import { addQueryParamsToURL, getDateForPayload, getTableQueryParams } from 'utils';

import { SnapDashboardDto, SnapsDashboard } from 'codegen';

export interface IInitialValues {
  locale: 'en_CA' | 'fr_CA';
  states: string[];
  isPartner: boolean;
  merchant?: string;
  collectorId?: string;
  isEscalated?: boolean;
  isFraudSuspicious?: boolean;
  isCollectorFraudster?: boolean;
  submittedDates: dayjs.Dayjs[] | null;
  collectorNumber: string;
  snapReferenceCode: string;
  claimReferenceCode: string;
  requiresTroubleshooting: string;
}

export const handleAllSnapsTableChange = (
  headers: RawAxiosRequestHeaders,
  setSearchParams: (nextInit: URLSearchParamsInit) => void,
  setSortOrderInfo: (data: SorterResult<SnapDashboardDto>) => void,
) => async (
  params: Params[0],
  {
    locale,
    states,
    merchant,
    isPartner,
    isEscalated,
    collectorId,
    submittedDates,
    collectorNumber,
    snapReferenceCode,
    claimReferenceCode,
    isFraudSuspicious,
    isCollectorFraudster,
    requiresTroubleshooting,
  }: IInitialValues,
) => {
  const flagged = requiresTroubleshooting === 'flagged';
  const tableQueryParams = getTableQueryParams(params, 'submitTimestamp');

  const queryParams = {
    ...tableQueryParams,
    ...(locale && { locale }),
    ...(states && { states }),
    ...(merchant && { merchant }),
    ...(isPartner && { isPartner }),
    ...(isEscalated && { isEscalated }),
    ...(isFraudSuspicious && { isFraudSuspicious }),
    ...(isCollectorFraudster && { isCollectorFraudster }),
    ...(collectorId && { collectorId }),
    ...(collectorNumber && { collectorNumber }),
    ...(snapReferenceCode && { snapReferenceCode }),
    ...(claimReferenceCode && { claimReferenceCode }),
    ...(requiresTroubleshooting && { requiresTroubleshooting: flagged }),
    ...(submittedDates && {
      submittedTo: getDateForPayload(dayjs(submittedDates[1]).endOf('day')),
      submittedFrom: getDateForPayload(dayjs(submittedDates[0]).startOf('day')),
    }),
  };

  setSearchParams(addQueryParamsToURL('', queryParams));

  if (params.sorter?.field) {
    setSortOrderInfo(params.sorter);
  }

  const url = addQueryParamsToURL('/snaps', queryParams);

  const { data } = await apiGet<SnapsDashboard>({ url, headers });

  return {
    list: data.snaps,
    total: data.total,
  };
};
